import {
    AlignmentType,
    Document,
    Packer,
    Paragraph,
    TextRun,
    Header,
    convertInchesToTwip, BorderStyle,
    Footer, PageBreak, Table, TableRow, TableCell, WidthType,ImageRun, VerticalAlign, PageOrientation, HeightRule
} from "docx";

const FileSaver = require("file-saver");
import MaterialService from "@/views/offer/material.service.js";
import MontageService from "@/views/offer/montage.service";

const CertainCustomer = {
    Gascade : "GASCADE Gastransport GmbH"
}

const logo = new ImageRun({
    data: 'data:image/png;base64,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',
    transformation: {
        width: 215,
        height: 49,
    },
});

const WordService = () => {

    const generateOffer = async (station, customer, offer, editedAddress, selectedUser) => {

        const documentCreator = new DocumentCreator();
        const doc = documentCreator.create([customer, offer, editedAddress, selectedUser, station]);
        const mimeType =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        const fileName = `${customer.name} - ${offer.angebotsNr} - ${new Date().toLocaleDateString()}.docx`;
        Packer.toBlob(doc).then((blob) => {
            const docblob = blob.slice(0, blob.size, mimeType);
            FileSaver.saveAs(docblob, fileName);
        });
    };

    const col_12 = 9010
    const col_11 = 751 * 11;
    const col_10 = 751 * 10;
    const col_9 = 751 * 9;
    const col_8 = 751 * 8;
    const col_7 = 751 * 7;
    const col_6 = 4505;
    const col_5 = 3754;
    const col_4 = 3004;
    const col_3 = 2252;
    const col_2 = 1502;
    const col_1_5 = 751 * 1.5;
    const col_1 = 751;

    /**
     *
     * @returns {TableRow}
     */
    function getMaterialRows(machines) {
        let tableCells = [];
        let tableRows = [];

        let sum = 0;

        /**
         * tableheader
         */
        tableRows.push(new TableRow({
            children: [
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            style: 'tableCellHeader',
                            text: "Pos."
                        })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                    // verticalAlign: VerticalAlign.CENTER, funzt

                }),
                new TableCell({
                    width: {
                        size: col_4,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            style: 'tableCellHeader',
                            text: "Benennung"
                        })],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    width: {
                        size: col_2,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            style: 'tableCellHeader',
                            text: "Artikelnummer"
                        })],
                    verticalAlign: VerticalAlign.CENTER,

                }),
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            style: 'tableCellHeader',
                            text: "Stk"
                        })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    width: {
                        size: col_2,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            style: 'tableCellHeader',
                            text: "Preis/Stk. €"
                        })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    background: {
                        color: "C45911",
                    },
                    width: {
                        size: col_2,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        text: "Preis/Pos. €",
                        style: 'tableCellHeader',
                    })],
                    verticalAlign: VerticalAlign.CENTER,
                }),
            ]
        }))

        /**
         * tablerows
         */
        for (const [index, value] of machines.entries()) {
            tableCells = [];
            sum += value.preisPos;
            tableCells.push(
                new TableCell({
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text:`${1}.${1 + index}`,
                                    font: "Arial",
                                    size: 20,
                                })
                            ],
                            style: 'textCenter',
                        })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: value.kurztext,
                                    font: "Arial",
                                    size: 20,
                                })
                                ]
                        })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `${value.artikelNr}`,
                                    font: "Arial",
                                    size: 20,
                                })
                            ],

                            style: 'textCenter'
                        })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `${value.stk}`,
                                    font: "Arial",
                                    size: 20,
                                })
                            ],
                            style: 'textCenter',
                        })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    children: [
                        new Paragraph(
                            {
                                children: [
                                    new TextRun({
                                        text: currencyParser(value.preisStk),
                                        font: "Arial",
                                        size: 20,
                                    })
                                ],
                                style: 'textRight',
                            }
                        ),
                        ],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: currencyParser(value.preisPos),
                                    font: "Arial",
                                    size: 20,
                                })
                            ],
                            style: 'textRight',
                        })],
                    verticalAlign: VerticalAlign.CENTER,
                }),
            )

            tableRows.push(new TableRow({children: tableCells}));

        }
        tableRows.push(new TableRow(
            {
                children: [
                    new TableCell({
                        columnSpan: 7,
                        children: [
                            new Paragraph({
                                style: 'textRight',
                                children: [
                                    new TextRun({
                                        text: currencyParser(sum),
                                        bold: true,
                                        font: "Arial",
                                        size: 24,
                                    })
                                ]
                            })],
                    }),
                ]
            }
        ));

        return tableRows;
    }

    function getMontageRows(customer, machines, offer, col_4, col_1, col_3) {
        let tableCells = [];
        let tableRows = [];
        let montageService = MontageService(CertainCustomer.Gascade === customer.name);
        let montageBenennung = ['Halbtagespauschale', 'Tagespauschale', 'Überstunden', 'Übernachtung', 'Reisekostenpauschale']
        let montageStueck = ['halbtagspauschale', 'tagespauschale', 'ueberstunden', 'uebernachtung', 'reisekostenpauschale']
        let montageStueckpreise = [montageService.getHalbtagesPauschale(offer.montage), montageService.getTagesPauschale(offer.montage), montageService.UEBERSTUNDE, montageService.UEBERNACHTUNGSPAUSCHALE, montageService.getEntfernung(offer.montage)]
        let montagePospreise = [montageService.halbtagesPauschale_summe(offer.montage), montageService.tagesPauschale_summe(offer.montage), montageService.ueberstunden_summe(offer.montage), montageService.uebernachtung_summe(offer.montage), montageService.getEntfernung_summe(offer.montage)]


        /**
         * tableheader
         */
        tableRows.push(new TableRow({
            children: [
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        text:"Pos.",
                        style: 'tableCellHeader'
                    })],
                    margins: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10,
                        marginUnitType:  WidthType.AUTO
                    }

                }),
                new TableCell({
                    width: {
                        size: col_5,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        text: "Beschreibung",
                        style: 'tableCellHeader'
                    })],
                    margins: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10,
                        marginUnitType:  WidthType.AUTO
                    }
                }),

                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        text: "Menge",
                        style: 'tableCellHeader'
                    })],
                    margins: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10,
                        marginUnitType:  WidthType.AUTO
                    }
                }),
                new TableCell({
                    width: {
                        size: col_3,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        text: "Preis/Stk. €",
                        style: 'tableCellHeader'
                    })],
                    margins: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10,
                        marginUnitType:  WidthType.AUTO
                    }
                }),
                new TableCell({
                    width: {
                        size: col_3,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        text: "Preis/Pos. €",
                        style: 'tableCellHeader'
                    })],
                    margins: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10,
                        marginUnitType:  WidthType.AUTO
                    }
                }),
            ]
        }))

        /**
         * tablerows
         */
        for (let index = 0; index < montageBenennung.length; index++) {

            tableCells = [];
            tableCells.push(
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        children: [
                            new TextRun({
                                text: `${2}.${1 + index}`,
                                font: "Arial",
                                size: 20,
                            })
                        ],
                        style: 'textCenter',
                })],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: montageBenennung[index],
                                    font: "Arial",
                                    size: 20,
                                })
                            ],

                        })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                }),

                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `${offer.montage[montageStueck[index]]}`,
                                    font: "Arial",
                                    size: 20,
                                })
                            ],
                            style: 'textCenter'
                        })],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: currencyParser(montageStueckpreise[index]),
                                    font: "Arial",
                                    size: 20,
                                })
                            ],
                            style: 'textRight'
                            }
                        )
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        children: [
                            new TextRun({
                                text: currencyParser(montagePospreise[index]),
                                font: "Arial",
                                size: 20,
                            })
                        ],
                        style: 'textRight'
                    })
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                })
            )
            tableRows.push(new TableRow({children: tableCells}));

        }
        tableRows.push(new TableRow(
            {
                children: [
                    new TableCell({
                        columnSpan: 5,
                        children: [
                            new Paragraph({
                                style: 'textRight',
                                children: [
                                    new TextRun({
                                        text: currencyParser(montageService.getSum(offer.montage)),
                                        bold: true,
                                        size: 24,
                                        font: "Arial",
                                    })
                                ]
                            })],
                    }),
                ]
            }
        ));

        return tableRows;
    }

    function getDokumentationRows(entries) {
        let tableCells = [];
        let tableRows = [];

        /**
         * tableheader
         */
        tableRows.push(new TableRow({
            children: [
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph(
                            {
                                text: "Pos.",
                                style: 'tableCellHeader'
                            }
                            )
                    ],

                }),
                new TableCell({
                    width: {
                        size: col_8,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            text: "Benennung",
                            style: 'tableCellHeader'
                        })
                    ],
                }),
                new TableCell({
                    width: {
                        size: col_1,
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            text: "Std.",
                            style: 'tableCellHeader'
                    })]
                }),
                new TableCell({
                    width: {
                        size: col_2,
                        type: WidthType.DXA,
                    },
                    children: [new Paragraph({
                        text: "Preis",
                        style: 'tableCellHeader'
                    })]
                }),

            ]
        }))

        /**
         * tablerows
         */
        for (let index = 0; index < entries.length; index++) {

            tableCells = [];
            tableCells.push(
                new TableCell({
                    /*width: {
                        size: 10,
                        type: WidthType.PERCENTAGE,
                    },*/
                    children: [new Paragraph({
                        children: [
                            new TextRun({
                                text: `${3}.${1 + index}`,
                                size: 20,
                                font: "Arial",
                            })
                        ],

                        style: 'textCenter',
                    })],
                    verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                    /*width: {
                        size: 150,
                        type: WidthType.PERCENTAGE,
                    },*/
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `${entries[index].benennung}`,
                                    size: 20,
                                    font: "Arial",
                                })
                            ],
                    })],
                }),
                new TableCell({
                    /*width: {
                        size: 10,
                        type: WidthType.PERCENTAGE,
                    },*/
                    children: [new Paragraph({
                        children: [
                            new TextRun({
                                text: `${entries[index].std}`,
                                size: 20,
                                font: "Arial",
                            })
                        ],
                        style: 'textCenter',
                    })],
                }),
                new TableCell({
                    /*width: {
                        size: 30,
                        type: WidthType.PERCENTAGE,
                    },*/
                    children: [new Paragraph({
                        children: [
                            new TextRun({
                                text: currencyParser(entries[index].preis),
                                size: 20,
                                font: "Arial",
                            })
                        ],
                        style: 'textCenter',
                    })],
                }),
            )
            tableRows.push(new TableRow({children: tableCells}));
        }


        /**
         * tablerows
         */


        return tableRows;
    }

    function currencyParser(value) {
        return value.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2
        });
    }

    function getWartungspreis(item) {
        return MaterialService().getWartungspreis(item) * item.stk;
    }

    class DocumentCreator {
        create([customer, offer, editedAddress, selectedUser]) {
            const machines = offer.material.offerMachines;
            const materialTable = new Table({
                rows: getMaterialRows(machines),
            });

            const montageTable = new Table({
                columnWidths: [col_2, col_3, col_1, col_2, col_2],
                rows: getMontageRows(customer, machines, offer, col_4, col_1, col_3, col_2, col_1_5, col_12),
            });

            let dokumentationTableHeading;
            let dokumentationTable;
            let dokumentationTableBemerkungen;

            if(offer.documentationTableExist) {
                dokumentationTableHeading = new Paragraph({
                    style: 'heading1',
                    children: [
                        new TextRun({
                            text: "3. Dokumentation",
                            break: 2
                        })
                    ]
                });
                    // TODO: lösung finden für conditional leere Zeile
                    /*new Paragraph({
                        children: [],  // Just newline without text
                    }),*/

                dokumentationTable = new Table({
                    //columnWidths: 9008,
                    rows: getDokumentationRows(offer.documentationEntries),
                });

                dokumentationTableBemerkungen = new Paragraph({
                    children: [
                        new TextRun({
                            text: "Bemerkung zur Dokumentation:",
                            break: 1,
                            bold: true,
                            font: "Arial",
                            size: 20
                        }),
                        new TextRun({
                            text: `${offer.bemerkungDokumentation}`,
                            break: 2,
                            bold: false,
                            font: "Arial",
                            size: 20
                        }),
                    ]
                })
            }

            const document = new Document({
                styles: {
                    paragraphStyles: [
                        {
                            id: "normalPara",
                            name: "Normal Para",
                            basedOn: "Normal",
                            next: "Normal",
                            quickFormat: true,
                            run: {
                                font: "Arial",
                                size: 20,
                                bold: false,
                                // color: "dddddd",
                                italics: false,
                            }
                        },
                        {
                            id: 'firstPageIntro',
                            run: {
                                font: "Arial",
                            },
                            /*paragraph: {
                                indent: {
                                    left: convertInchesToTwip(0.2),
                                }
                            },*/
                        },
                        {
                            id: 'firstPageIndent',
                            run: {
                                font: "Arial",
                                size: 20,
                                bold: false,
                                // color: "dddddd",
                                italics: false,
                            },
                            /*paragraph: {
                                indent: {
                                    left: convertInchesToTwip(0.2),
                                }
                            },*/
                        },

                        {
                            id: 'firstPageRemoveIndent',
                            run: {
                                font: "Arial",
                                size: 20,
                                bold: false,
                                // color: "dddddd",
                                italics: false,
                            },
                            paragraph: {
                                indent: {
                                    left: convertInchesToTwip(0),
                                }
                            },
                        },
                        {
                            id: 'textRight',
                            paragraph: {
                                alignment: AlignmentType.RIGHT
                            }
                        },
                        {
                            id: 'textCenter',
                            paragraph: {
                                alignment: AlignmentType.CENTER
                            }
                        },
                        {
                            id: 'arial10',
                            run: {
                                font: "Arial",
                                size: 20,
                            },
                        },

                        {
                            id: 'heading1',
                            run: {
                                font: "Arial",
                                size: 20,
                                bold: true
                            },
                        },
                        {
                            id: 'fontFooter',
                            run: {
                                font: "Arial",
                                size: 16
                            },
                        },
                        {
                            id: 'tableCellHeader',
                            run: {
                                font: "Arial",
                                size: 16,
                                bold: true
                            },
                            paragraph: {
                                alignment: AlignmentType.CENTER,
                            }
                        },
                        {
                            id: 'verticalAlignCenter',
                            paragraph: {
                                alignment: AlignmentType.CENTER,
                            }
                        },


                    ]
                },
                sections: [{
                    headers: {
                        default: new Header({
                            children: [
                                new Table({
                                    rows: [
                                        new TableRow({
                                            children: [
                                                new TableCell({
                                                    borders: {
                                                        top: {
                                                            style: BorderStyle.DASH_SMALL_GAP,
                                                            size: 0,
                                                            color: "ffffff",
                                                        },
                                                        bottom: {
                                                            style: BorderStyle.SINGLE,
                                                            size: 0,
                                                            /*color: "3eb286",*/
                                                            color: "ffffff",
                                                        },
                                                        left: {
                                                            style: BorderStyle.DASH_SMALL_GAP,
                                                            size: 0,
                                                            color: "ffffff",
                                                        },
                                                        right: {
                                                            style: BorderStyle.DASH_SMALL_GAP,
                                                            size: 0,
                                                            color: "ffffff",
                                                        },
                                                    },
                                                    width: {
                                                        size: 4504,
                                                        type: WidthType.DXA
                                                    },

                                                    children: [

                                                        new Paragraph({
                                                            children: [
                                                                logo
                                                            ],
                                                        }),
                                                    ],
                                                }),

                                                new TableCell({
                                                    borders: {
                                                        top: {
                                                            style: BorderStyle.SINGLE,
                                                            size: 0,
                                                            color: "ffffff",
                                                        },
                                                        bottom: {
                                                            style: BorderStyle.SINGLE,
                                                            size: 0,
                                                            /*color: "3eb286",*/
                                                            color: "ffffff",
                                                        },
                                                        left: {
                                                            style: BorderStyle.DASH_SMALL_GAP,
                                                            size: 0,
                                                            color: "ffffff",
                                                        },
                                                        right: {
                                                            style: BorderStyle.DASH_SMALL_GAP,
                                                            size: 0,
                                                            color: "ffffff",
                                                        },
                                                    },
                                                    width: {
                                                        size: 4504,
                                                        type: WidthType.DXA
                                                    },
                                                    children: [
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: `${offer.angebotsNr}`,
                                                            alignment: AlignmentType.RIGHT,

                                                        })
                                                    ],
                                                    verticalAlign: VerticalAlign.BOTTOM,
                                                }),

                                            ]
                                        })
                                    ]
                                }),
                                new Paragraph({
                                    border: {
                                        top: {
                                            color: "3eb286",
                                            space: 1,
                                            style: BorderStyle.SINGLE,
                                            size: 6,
                                        }
                                    }
                                }),

                            ],
                        }),
                    },
                    footers: {
                        default: new Footer({
                            children: [
                                new Paragraph({
                                    border: {
                                        top: {
                                            color: "3eb286",
                                            space: 1,
                                            style: BorderStyle.SINGLE,
                                            size: 6,
                                        }
                                    }
                                }),
                                new Table({
                                    //columnWidths: [2272 * 2, 2272 * 2],
                                    rows: [
                                        new TableRow({
                                            children: [
                                                new TableCell({
                                                    borders: {
                                                        top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                    },
                                                    width: {
                                                        size: 28,
                                                        //size: 2252,
                                                        type: WidthType.PERCENTAGE
                                                    },

                                                    children: [

                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'Fahlke Control Systems KG',
                                                        }),
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'Rudolf-Diesel Str. 3',
                                                        }),
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'D-27356 Rotenburg (Wuemme)',
                                                        })
                                                    ],
                                                }),

                                                new TableCell({
                                                    borders: {
                                                        top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                    },
                                                    width: {
                                                        //size: 2252,
                                                        size: 25,
                                                        type: WidthType.PERCENTAGE
                                                    },
                                                    children: [
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'Phone :+49 4261 9143 0',
                                                        }),
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'Fax : +49 4261 9143 143'
                                                        }),
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'E-Mail : csg@fahlke.de',
                                                        })
                                                    ],
                                                }),
                                                new TableCell({
                                                    borders: {
                                                        top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                    },
                                                    width: {
                                                        size: 32,
                                                        // size: 2252,
                                                        type: WidthType.PERCENTAGE
                                                    },
                                                    children: [
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'Amtsgericht Walsrode HRA62027',
                                                        }),
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'Gerichtsstand Rotenburg'
                                                        }),
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'Ust-IdNr.: DE 116324270',
                                                        })
                                                    ],
                                                }),
                                                new TableCell({
                                                    borders: {
                                                        top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                        right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
                                                    },
                                                    width: {
                                                        size: 15,
                                                        type: WidthType.PERCENTAGE
                                                    },
                                                    children: [
                                                        new Paragraph({
                                                            style: 'fontFooter',
                                                            text: 'Markus Fahlke (GF)',
                                                        })
                                                    ],
                                                })

                                            ]
                                        })
                                    ]
                                }),
                            ],
                        }),
                    },
                    properties: {
                        page: {
                            size: {
                                orientation: PageOrientation.PORTRAIT,
                            },
                        },
                    },
                    children: [
                        new Paragraph({
                            children: []
                        }),

                        new Table({
                            rows: [
                                new TableRow({
                                    children: [
                                        new TableCell({
                                            borders: {
                                                top: {
                                                    style: BorderStyle.DASH_SMALL_GAP,
                                                    size: 0,
                                                    color: "ffffff",
                                                },
                                                bottom: {
                                                    style: BorderStyle.DASH_SMALL_GAP,
                                                    size: 0,
                                                    color: "ffffff",
                                                },
                                                left: {
                                                    style: BorderStyle.DASH_SMALL_GAP,
                                                    size: 0,
                                                    color: "ffffff",
                                                },
                                                right: {
                                                    style: BorderStyle.DASH_SMALL_GAP,
                                                    size: 0,
                                                    color: "ffffff",
                                                },
                                            },
                                            width: {
                                                size: col_7,
                                                type: WidthType.DXA
                                            },
                                            children: [this.createCustomer(customer, editedAddress)],
                                        }),
                                        new TableCell({
                                            borders: {
                                                top: {
                                                    style: BorderStyle.DASH_SMALL_GAP,
                                                    size: 0,
                                                    color: "ffffff",
                                                },
                                                bottom: {
                                                    style: BorderStyle.DASH_SMALL_GAP,
                                                    size: 0,
                                                    color: "ffffff",
                                                },
                                                left: {
                                                    style: BorderStyle.DASH_SMALL_GAP,
                                                    size: 0,
                                                    color: "ffffff",
                                                },
                                                right: {
                                                    style: BorderStyle.DASH_SMALL_GAP,
                                                    size: 0,
                                                    color: "ffffff",
                                                },
                                            },
                                            width: {
                                                size: col_5,
                                                type: WidthType.DXA
                                            },
                                            children: [this.createFahlke(selectedUser)],
                                        }),

                                    ]
                                })
                            ]
                        }),

                        new Paragraph({
                            style: 'firstPageIntro',
                            children: [
                                new TextRun({
                                    text: `Angebots-Nr.: ${offer.angebotsNr}`,
                                    break: 3,
                                    bold: true,
                                    size: 24,

                                }),
                                new TextRun({
                                    text: `Ihre Anfrage:`,
                                    break: 2,
                                    bold: true,
                                }),
                                new TextRun({
                                    bold: true,
                                    text: `${offer.ihreAnfrage}`,
                                    size: 20

                                }),

                                new TextRun({
                                    text: `Sehr geehrte/r ${offer.contactPerson}`,
                                    break: 2,
                                    bold: true,
                                    size: 20
                                }),
                                new TextRun({
                                    text: `${offer.anrede}`,
                                    break: 2,
                                })
                            ]
                        }),



                        new Paragraph({
                            style: 'firstPageIndent',
                            children: [
                                new TextRun({
                                    text: `Kommerzielle Bedingung:`,
                                    underline: true,
                                    break: 2
                                }),
/*

                                new TextRun({
                                    text: `Angebotswert Material: ${currencyParser(offer.material.angebotswertMaterial)}`,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Angebotswert Montage: ${currencyParser(offer.montage.sumMontage)}`,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Lieferzeit Material: ${offer.lieferzeitMaterial === null ? '-' : offer.lieferzeitMaterial} `,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Lieferzeit Montage: ${offer.lieferzeitMontage === null ? '-' : offer.lieferzeitMontage}`,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Lieferbedingung: ${offer.lieferbedingungen === null ? '-' : offer.lieferbedingungen}`,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Zahlungsbedingung: ${offer.zahlungsbedingungen === null ? '-' : offer.zahlungsbedingungen}`,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Gewährleistungen: ${offer.gewaehrleistungen === null ? '-' : offer.gewaehrleistungen}`,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Technische Lieferbedingung: ${offer.technischeLieferbedingungen === null ? '-' : offer.technischeLieferbedingungen}`,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Dokumentation: ${offer.dokumentationen === null ? '-' : offer.dokumentationen}`,
                                    break: 2
                                }),

                                new TextRun({
                                    text: `Angebotsgültigkeit: ${offer.angebotsgueltigkeit === null ? '-' : offer.angebotsgueltigkeit}`,
                                    break: 2
                                }),

*/

                            ]
                        }),

                        this.createTableMable(offer),

                        /*new Table({
                            rows: [
                                new TableRow({
                                    children: [
                                        new TableCell({
                                            margins: {
                                                marginUnitType: WidthType.DXA,
                                                top: 100,
                                                bottom: 100
                                            },
                                            children: [
                                                new Paragraph({
                                                    text:"Hello"
                                                })
                                            ],
                                            width: {
                                                size: col_4,
                                                type: WidthType.DXA
                                            },
                                        }),
                                        new TableCell({
                                            margins: {
                                                marginUnitType: WidthType.DXA,
                                                top: 100,
                                                bottom: 100
                                            },
                                            children: [
                                                new Paragraph("yellow")
                                            ],
                                            width: {
                                                size: col_8,
                                                type: WidthType.DXA
                                            },
                                        }),
                                    ],
                                }),
                            ],
                        }),*/


                        new Paragraph({
                            style: 'firstPageRemoveIndent',
                            children: [
                                new TextRun({
                                    text: `Mit freundlichen Grüßen`,
                                    break: 2,

                                }),

                                new TextRun({
                                    text: `Fahlke Control Systems`,
                                    break: 1
                                }),
                                new TextRun({
                                    text: ``,
                                    break: 2
                                })

                            ]
                        }),
                        new Paragraph({
                            style: 'firstPageRemoveIndent',
                            children: [
                                new TextRun({
                                    text: `${selectedUser.name}`

                                })
                            ]
                        }),
                        new Paragraph({
                            children: [new PageBreak()]
                        }),
                        // new Paragraph("1. Material"),
                        new Paragraph({
                            style: 'heading1',
                            children: [
                                new TextRun({
                                    text: "1. Material",
                                    bold: true,
                                    break: 2
                                })
                            ]
                        }),
                        new Paragraph({
                            children: [],  // Just newline without text
                        }),
                        materialTable,

                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Bemerkung zu Material:",
                                    break: 1,
                                    font: "Arial",
                                    bold: true,
                                    size: 20
                                }),
                                new TextRun({
                                    text: `${offer.bemerkungMaterial}`,
                                    break: 2,
                                    bold: false,
                                    font: "Arial",
                                    size: 20
                                }),
                            ]
                        }),

                        new Paragraph({
                            style: 'heading1',
                            children: [
                                new TextRun({
                                    text: "2. Montageaufwand",
                                    break: 2
                                })
                            ]
                        }),
                        new Paragraph({
                            children: [],  // Just newline without text
                        }),
                        montageTable,
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Bemerkung zu Montage:",
                                    break: 1,
                                    font: "Arial",
                                    bold: true,
                                    size: 20
                                }),
                                new TextRun({
                                    text: `${offer.bemerkungMontage}`,
                                    break: 2,
                                    bold: false,
                                    font: "Arial",
                                    size: 20
                                }),
                            ]
                        }),

                        // Doku
                        dokumentationTableHeading,
                        dokumentationTable,
                        dokumentationTableBemerkungen,
                        /*new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Bemerkung zur Dokumentation:",
                                    break: 1
                                }),
                                new TextRun({
                                    text: `${offer.bemerkungDokumentation}`,
                                    break: 2,
                                    bold: false
                                }),
                            ]
                        }),*/


                    ]
                }]
            });

            return document;
        }

        createTableMable(offer) {
            return new Table({
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Angebotswert Material:"
                                    })
                                ],
                                width: {
                                    size: 30,
                                    type: WidthType.PERCENTAGE
                                },
                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: currencyParser(offer.material.angebotswertMaterial) + ' netto zzgl. MwSt.'
                                        }
                                    )
                                ],
                                width: {
                                    size: 70,
                                    type: WidthType.PERCENTAGE
                                },
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Angebotswert Montage:"
                                    })
                                ],

                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: currencyParser(offer.montage.sumMontage) + ' netto zzgl. MwSt.'
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Lieferzeit Material:"
                                    })
                                ],

                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: offer.lieferzeitMaterial === null ? '-' : offer.lieferzeitMaterial
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Lieferzeit Montage:"
                                    })
                                ],

                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: offer.lieferzeitMontage === null ? '-' : offer.lieferzeitMontage
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Lieferbedingung:"
                                    })
                                ],

                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: offer.lieferbedingungen === null ? '-' : offer.lieferbedingungen
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Zahlungsbedingung:"
                                    })
                                ],

                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: offer.zahlungsbedingungen === null ? '-' : offer.zahlungsbedingungen
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Gewährleistungen:"
                                    })
                                ],

                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: offer.gewaehrleistungen === null ? '-' : offer.gewaehrleistungen
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Technische Lieferbedingung:"
                                    })
                                ],

                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: offer.technischeLieferbedingungen === null ? '-' : offer.technischeLieferbedingungen
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Dokumentation:"
                                    })
                                ],

                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: offer.dokumentationen === null ? '-' : offer.dokumentationen
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph({
                                        style: 'firstPageIndent',
                                        text:"Angebotsgültigkeit:"
                                    })
                                ],
                            }),
                            new TableCell({
                                borders: {
                                    top: {
                                        color: "ffffff",
                                    },
                                    bottom: {
                                        color: "ffffff",
                                    },
                                    left: {
                                        color: "ffffff",
                                    },
                                    right: {
                                        color: "ffffff",
                                    },
                                },
                                margins: {
                                    marginUnitType: WidthType.DXA,
                                    top: 100,
                                    bottom: 100
                                },
                                children: [
                                    new Paragraph(
                                        {
                                            style: 'firstPageIndent',
                                            text: offer.angebotsgueltigkeit === null ? '-' : offer.angebotsgueltigkeit
                                        }
                                    )
                                ],
                            }),
                        ],
                    }),

                ],
            })
        }

        createFahlke(selectedUser) {
            return new Paragraph({
                style: "normalPara",
                children: [
                    new TextRun(
                        {
                            text: 'from:',
                            italics: true,
                            font: "Arial"
                        }
                    ),
                    new TextRun({
                        text: 'Fahlke Control Systems KG',
                        bold: true,
                        break: 2,
                    }),
                    new TextRun({
                        text: `${(selectedUser.nameShort) ? selectedUser.nameShort: selectedUser.name} ` + `(${selectedUser.title})`,
                        break: 1,
                        bold: true
                    }),
                    new TextRun({
                        text: `Datum: ${new Date().toLocaleDateString()}`,
                        break: 1,
                    }),

                    new TextRun({
                        text: `Tel.: ${selectedUser.tel} `,
                        break: 2
                    }),
                    new TextRun({
                        text: `Fax: ${selectedUser.fax} `,
                        break: 1
                    }),
                    new TextRun({
                        text: `E-Mail: ${selectedUser.email} `,
                        break: 1
                    }),

                    new TextRun({
                        text: `Kopie: ${selectedUser.cc} `,
                        break: 1
                    })
                ],
            });
        }

        createCustomer(customer, editedAddress) {
            return new Paragraph({
                style: "normalPara",
                children: [
                    new TextRun({
                        text: 'to:',
                        italics: true,
                        font: "Arial"
                    }),
                    new TextRun({
                        text: `${editedAddress.customerName}`,
                        bold: true,
                        break: 2
                    }),
                    new TextRun({
                        text: `${editedAddress.contactPerson}`,
                        break: 1,
                        bold: true
                    }),
                    new TextRun({
                        text: `${editedAddress.street} ${editedAddress.houseNo}`,
                        break: 2
                    }),
                    new TextRun({
                        text: `${editedAddress.zipCode} ${editedAddress.city}`,
                        break: 1
                    }),
                    new TextRun({
                        text: `${editedAddress.country}`,
                        break: 1
                    }),
                    new TextRun({
                        text: `Tel: ${customer.phone}`,
                        break: 2
                    }),
                    new TextRun({
                        text: `Email: ${editedAddress.mail}`,
                        break: 1
                    })
                ],
            });
        }

    }

    return {
        generateOffer
    };
};

export default WordService
